import { useQuery } from '@tanstack/react-query';
import { cifStampService, type CifStampData } from '@/services/cifStampService';
import { queryKeys } from '@/lib/queryKeys';
import { useAuth } from '@/hooks/useAuth';

export const useCifStamp = () => {
  const { isAuthenticated } = useAuth();
  return useQuery<CifStampData>({
    queryKey: queryKeys.cifStamp.detail,
    queryFn: () => cifStampService.get(),
    enabled: isAuthenticated,
    staleTime: 0,
  });
};
